/**
 * @desc        Chemical Records
 * @version     1.1 - 1 Feb 22 **/

import * as actionTypes from '../../actions/action-types.js'

const initialState = {
    spraying: {
        lastFetch: 0,
        loading: false,
    },
    agrichemical: {
        lastFetch: 0,
        loading: false,
    },
    pestchemical: {
        lastFetch: 0,
        loading: false,
    },
    vetchemical: {
        lastFetch: 0,
        loading: false,
    },
}
const chemicalsrecord = (state = initialState, action) => {
    const { data, type } = action || {}

    switch (type) {
        case actionTypes.STORE_INIT:
            return {
                ...initialState,
            }
        case actionTypes.FD_SPRAY_RECORDS_UPDATE:
            return {
                ...state,
                spraying: {
                    ...state.spraying,
                    loading: false,
                    data: data,
                },
            }
        case actionTypes.FD_SPRAY_RECORDS_REQUEST_SUCCESS:
            return {
                ...state,
                spraying: {
                    ...state.spraying,
                    loading: false,
                    lastFetch: Date.now(),
                    lastFarmId: action.lastFarmId,
                    data: data,
                },
            }
        case actionTypes.FD_SPRAY_RECORDS_REQUEST:
            return {
                ...state,
                spraying: {
                    ...state.spraying,
                    loading: true,
                },
            }
        case actionTypes.FD_SPRAY_RECORDS_REQUEST_FAILURE:
            return {
                ...state,
                spraying: {
                    ...state.spraying,
                    loading: false,
                    error: action.error,
                    lastError: Date.now(),
                },
            }
        case actionTypes.FD_AGRICHEMICAL_RECORDS_UPDATE:
            return {
                ...state,
                agrichemical: {
                    ...state.agrichemical,
                    loading: false,
                    data: data,
                },
            }
        case actionTypes.FD_AGRICHEMICAL_RECORDS_REQUEST_SUCCESS:
            return {
                ...state,
                agrichemical: {
                    ...state.agrichemical,
                    loading: false,
                    lastFetch: Date.now(),
                    lastFarmId: action.lastFarmId,
                    data: data,
                },
            }
        case actionTypes.FD_AGRICHEMICAL_RECORDS_REQUEST:
            return {
                ...state,
                agrichemical: {
                    ...state.agrichemical,
                    loading: true,
                },
            }
        case actionTypes.FD_AGRICHEMICAL_RECORDS_REQUEST_FAILURE:
            return {
                ...state,
                agrichemical: {
                    ...state.agrichemical,
                    loading: false,
                    error: action.error,
                    lastError: Date.now(),
                },
            }
        case actionTypes.FD_PESTCHEMICAL_RECORDS_UPDATE:
            return {
                ...state,
                pestchemical: {
                    ...state.pestchemical,
                    loading: false,
                    data: data,
                },
            }
        case actionTypes.FD_PESTCHEMICAL_RECORDS_REQUEST_SUCCESS:
            return {
                ...state,
                pestchemical: {
                    ...state.pestchemical,
                    loading: false,
                    lastFetch: Date.now(),
                    lastFarmId: action.lastFarmId,
                    data: data,
                },
            }
        case actionTypes.FD_PESTCHEMICAL_RECORDS_REQUEST:
            return {
                ...state,
                pestchemical: {
                    ...state.pestchemical,
                    loading: true,
                },
            }
        case actionTypes.FD_PESTCHEMICAL_RECORDS_REQUEST_FAILURE:
            return {
                ...state,
                pestchemical: {
                    ...state.pestchemical,
                    loading: false,
                    error: action.error,
                    lastError: Date.now(),
                },
            }
        case actionTypes.FD_VETCHEMICAL_RECORDS_UPDATE:
            return {
                ...state,
                vetchemical: {
                    ...state.vetchemical,
                    loading: false,
                    data: data,
                },
            }
        case actionTypes.FD_VETCHEMICAL_RECORDS_REQUEST_SUCCESS:
            return {
                ...state,
                vetchemical: {
                    ...state.vetchemical,
                    loading: false,
                    lastFetch: Date.now(),
                    lastFarmId: action.lastFarmId,
                    data: data,
                },
            }
        case actionTypes.FD_VETCHEMICAL_RECORDS_REQUEST:
            return {
                ...state,
                vetchemical: {
                    ...state.vetchemical,
                    loading: true,
                },
            }
        case actionTypes.FD_VETCHEMICAL_RECORDS_REQUEST_FAILURE:
            return {
                ...state,
                vetchemical: {
                    ...state.vetchemical,
                    loading: false,
                    error: action.error,
                    lastError: Date.now(),
                },
            }
        default: {
            return state
        }
    }
}

export default chemicalsrecord
